export const BOX_SIZE = 0.8;

export const HOVER_HEIGHT = 1;

export const ENERGY_MASS = 1;

export const ENERGY_FRICTION = 0.8;

export const ENERGY_RESTITUTION = 0.35;

export const DRAG_LERP = 0.2;

export const DRAG_LIFT_HEIGHT = 3;

export const DRAG_ROLL_SPEED = 0.1;
